<template>
  <!-- 底部 -->
  <!-- 方案特点 -->
  <div class="constitute" :style="{'backgroundColor': background}">
    <div>
      <div class="title">{{ title }}</div>
      <div class="content">
        <div class="list" v-for="(item,index) of constitute" :key="index">
          <template v-for="itemSon of item">
            <div>
              <div class="headline">
                <img
                  src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/wisdom/1.png"
                  alt=""
                />
                <div>{{ itemSon.title }}</div>
              </div>
              <div class="desc">
                {{ itemSon.desc }}
              </div>
            </div>
          </template>
          <div class="nopx-line" v-if="index!=2"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: '方案特点'
    },
    background: {
      type: String,
      default: ''
    },
    constitute: {
      type: Array,
      default: () => {
        return [[
          {
            title:'1',
            desc: '2'
          },{
            title:'3',
            desc: '4'
          }
        ],[
          {
            title:'1',
            desc: '2'
          },{
            title:'3',
            desc: '4'
          }
        ],[
          {
            title:'1',
            desc: '2'
          },{
            title:'3',
            desc: '4'
          }
        ]];
      }
    }
  },
  data: function() {
    return {
      data: {
        menu_list: []
      }
    };
  },
  created() {},
  methods: {
    go() {
      this.$router.push({
        name: 'eg'
      });
    }
  }
};
</script>
<style lang="less" scoped>
.constitute {
  background-image: url(~@/assets/images/background.png);
  background-size: 100% 100%;
  > div {
    width: 1200px;
    height: 708px;
    margin: 0 auto;
    overflow: hidden;
    .title {
      text-align: center;
      margin-top: 161px;
      line-height: 1;
      font-size: 42px;
      font-weight: bold;
      color: #ffffff;
    }
    .content {
      display: flex;
      .list {
        width: 33%;
        height: 398px;
        position: relative;
        padding: 0 45px;
        box-sizing: border-box;
        .headline {
          display: flex;
          align-items: center;
          margin-top: 42px;
          font-size: 36px;
          font-weight: 400;
          color: #ffffff;
          line-height: 1;
          img {
            width: 36px;
            height: 36px;
            margin-right: 26px;
          }
        }
        .desc {
          font-size: 18px;
          color: #ffffff;
          line-height: 24px;
          margin-top: 10px;
          min-height: 120px;
        }
        .nopx-line {
          width: 1px;
          height: 100%;
          position: absolute;
          top: 0;
          right: -1px;
          background: linear-gradient(
            180deg,
            rgba(255, 255, 255, 0),
            #fff,
            rgba(255, 255, 255, 0.1)
          );
        }
        &:nth-child(3) .line {
          display: none;
        }
      }
    }
  }
}
@media (max-width: 1000px) {
  .constitute{
    background-size: 100%;
    background-repeat: no-repeat;
    > div{
      width: 100%;
      height: auto;
      .title{
        motion-path: 120px;
        font-size: 44px;
      }
      .content{
        display: block;
        background: #F27529;;
        padding-top: 1px;
        padding-bottom: 100px;
        .list{
          width: 100%;
          height: auto;
          display: flex;
          justify-content: space-between;
          margin-top: 80px;
          padding: 0 60px;
          background-color: #F27529;
          > div{
            width: 284px;
            .headline{
              font-size: 36px;
              margin-top: 0;
              img{
                width: 48px;
                height: 48px;
              }
            }
            .desc{
              font-size: 28px;
              line-height: 1.3;
            }
          }
          .nopx-line{
            display: none;
          }
        }
      }
    }
  }
}
</style>
